import { Component, OnInit } from '@angular/core';
import { User } from '@sb-shared/models/user';
import { forkJoin } from 'rxjs';
import { VideoBackgroundService } from '@sb-shared/services/video-background.service';
import { BackgroundOption } from '@sb-shared/models/UI/background-option';
import { ProfileDataService } from '../../services/profile-data.service';
import { environment } from 'src/environments/environment';
import { ProfilePersonalisationService } from '../../services/profile-personalisation.service';

@Component({
  selector: 'sb-profile-personalisation',
  templateUrl: './profile-personalisation.component.html',
  styleUrls: ['./profile-personalisation.component.scss'],
  standalone: false
})
export class ProfilePersonalisationComponent implements OnInit {
  selectedPerson: User;
  isSaving = false;
  videoBackgroundOptions: BackgroundOption[] = [];
  cdnBase: string = environment.cdnBase;
  selectedBackgroundOptionId: number;

  constructor(
    private profileDataService: ProfileDataService,
    private personalisationService: ProfilePersonalisationService,
    private videoBackgroundService: VideoBackgroundService
  ) { }

  ngOnInit(): void {
    forkJoin([
      this.videoBackgroundService.getBackgroundOptions(),
      this.profileDataService.getUserInContext(),
    ]).subscribe(([videoBackgroundOptions, user]: [BackgroundOption[], User]) => {
      this.videoBackgroundOptions = videoBackgroundOptions;
      this.selectedPerson = user;

      if (videoBackgroundOptions.length > 0) {
        this.personalisationService.getPersonalisationSettings(this.selectedPerson.id)
          .subscribe((personalisationSettings) => {
            if (personalisationSettings) {
              this.selectedBackgroundOptionId = personalisationSettings.videoBackgroundOptionId;
            } else {
              const defaultOption = videoBackgroundOptions.find(option => option.isDefault === true);
              this.selectedBackgroundOptionId = defaultOption ? defaultOption.id : null;
            }
          });
      }
    });
  }

  onBackgroundChange(selectedBackfroundOption: BackgroundOption) {
    this.selectedBackgroundOptionId = selectedBackfroundOption.id;
  }

  save() {
    this.isSaving = true;
    this.personalisationService.updatePersonalisationSettings(this.selectedPerson.id, this.selectedBackgroundOptionId)
      .subscribe((data) => {
        setTimeout(() => {
          this.isSaving = false;
        });
      });
  }
}
